import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { CustomBreakPointsProvider } from 'app/componentes/layout/custom-breakpoints';
import { VerticalLayoutModule } from 'app/componentes/layout/vertical/vertical-layout.module';
import { HorizontalLayoutModule } from 'app/componentes/layout/horizontal/horizontal-layout.module';

@NgModule({
  imports: [FlexLayoutModule.withConfig({ disableDefaultBps: false }), VerticalLayoutModule, HorizontalLayoutModule],
  providers: [CustomBreakPointsProvider],
  exports: [VerticalLayoutModule, HorizontalLayoutModule]
})
export class LayoutModule {}
